import { EmbedTheme } from "../../utils/embeds";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3PoweredBy } from "./V3EmbedPoweredBy.styles";

interface V3EmbedPoweredByProps {
    embedTheme: EmbedTheme,
    utmCampaign: string,
}

export const V3EmbedPoweredBy = ({ embedTheme, utmCampaign }: V3EmbedPoweredByProps) => <UnstyledLink href={`${process.env.NEXT_PUBLIC_FRONTEND_URL}?utm_source=link&utm_medium=embed&utm_campaign=${utmCampaign}`} target="_blank">
    <V3PoweredBy $embedTheme={embedTheme}>Powered by Authory</V3PoweredBy>
</UnstyledLink>